// extracted by mini-css-extract-plugin
export default {"backdrop":"PaymentConfirmationLayout_backdrop__0qD4N","overlay":"PaymentConfirmationLayout_overlay__WYn33"};